import useAuthenticatedAxios from "./use-authenticated-axios";
import useSWR from "swr";
import { useMemo } from "react";

import useAuth from "./use-auth.js";

const ROOT_URL = "/stats/loyer-hc-charges";

export default function useStats(
  debut,
  fin,
  property_ids,
  profile_bailleur_ids,
) {
  const axios = useAuthenticatedAxios();
  const { userId } = useAuth();
  const fallbackData = useMemo(() => [], []);
  const {
    data: loyerHcVsCharges,
    error,
    isLoading,
  } = useSWR(
    {
      url: ROOT_URL,
      filter: { debut, fin, property_ids, profile_bailleur_ids },
      userId,
    },
    ({ url, filter }) => {
      return axios.post(url, filter).then((res) => res.data);
    },
    { fallbackData },
  );

  return {
    loyerHcVsCharges,
    error,
    isLoading,
  };
}
